module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "preface1",
    attrs: {
      "id": "col"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent3"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780312602765_001.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_vm._v("you go along")]), _vm._v(", minding your own business (more or less), then BAM! You win the lottery, a piano falls on your head, you’re struck by lightning and fried to a crisp. Or, like Izzy Miller, your plain old swollen glands turn out to bea kind of cancer you never even heard of before. From that second on, everything and everyone around you gets weirder than weird, and your only choice isto push through it—or in Izzy’s case, puke through it—and try to stay sane.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And, as if it doesn’t suck enough to have cancer, practically every time you pick up a book or see movies where characters get sick, you know they’ll be dead by the last scene.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In reality, kids get all kinds of cancers, go through unspeakable torture and painful treatments, but walk away fine in the end.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book is about that descent into hell, with a safe return. I dedicate it to everyone who has been there and back."), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780312602765_002.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780312602765_002.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_vm._v("deepest heartfelt gratitude")]), _vm._v(" to the amazing staff at Children’s Hospital, Los Angeles, especially Sherri Carcich, RN, care manager for the Leukemia and Lymphoma Program, and Dr. Anna Butturini, director of the ABMT Program, Center for Cancer and Blood Diseases, Children’s Hospital, Los Angeles.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent4"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780312602765_003.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1429e568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312602765_epub_col_r1.vue
// module id = 63
// module chunks = 0